import './LaneAssignmentBanner.css';

interface LaneAssignmentBannerProps {
  allyWarning: boolean;
  enemyWarning: boolean;
}

export function LaneAssignmentBanner({
  allyWarning,
  enemyWarning,
}: LaneAssignmentBannerProps) {
  if (!allyWarning && !enemyWarning) {
    return null;
  }

  return (
    <div className="lane-assignment-banner" role="status">
      {allyWarning && (
        <p className="lane-assignment-msg">
          味方チーム: 5レーンに矛盾なく割り当てられない構成です（グリッドからのピックはそのまま反映されます）。
        </p>
      )}
      {enemyWarning && (
        <p className="lane-assignment-msg">
          敵チーム: 5レーンに矛盾なく割り当てられない構成です（グリッドからのピックはそのまま反映されます）。
        </p>
      )}
    </div>
  );
}
